import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { ImageComponent } from 'common-ui';
import { ProductUnitLabels } from 'products-data';

import { ItemStockButtonComponent } from '../../../../../item';
import { ItemPriceComponent } from '../../../../../item/common/price/item-price';
import { ProductIdLabelComponent } from '../../../../common/basic-properties/product-id-label';
import { ProductIsCanadianComponent } from '../../../../common/basic-properties/product-is-canadian';
import { ProductNotReturnableComponent } from '../../../../common/basic-properties/product-not-returnable';
import { ProductShortDescriptionComponent } from '../../../../common/basic-properties/product-short-description';
import { RenderInProductResultLayoutDirective } from '../../../../layouts/product-result/product-result-layout/render-targets/render-in-product-result-layout.directive';
import { ProductResultLayoutComponentsProviderComponentBase } from '../../../../layouts/product-result/ProductResultLayoutComponentsProviderComponentBase';

@Component({
  selector: 'ideal-standard-product-result-components',
  imports: [
    RenderInProductResultLayoutDirective,
    ImageComponent,
    ProductShortDescriptionComponent,
    ProductIdLabelComponent,
    ProductIsCanadianComponent,
    ProductNotReturnableComponent,
    ItemPriceComponent,
    ItemStockButtonComponent,
  ],
  standalone: true,
  templateUrl: './standard-product-result-layout-components-provider.component.html',
  styleUrls: [
    '../../../../../product/layouts/product-result/product-result-base.scss',
    './standard-product-result-layout-components-provider.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StandardProductResultLayoutComponentsProviderComponent extends ProductResultLayoutComponentsProviderComponentBase {
  protected readonly unitLabel = computed(() => {
    const u = this.productDetails()?.unit ?? '';
    return ProductUnitLabels[u as keyof typeof ProductUnitLabels] ?? { other: u };
  });
}
